import { useMemo } from 'react';
import { Alert, Box } from '@nimbus-ds/components';
import type { StoreDomainDto } from '@tiendanube/common';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';

interface ConfiguringDomainAlertProps {
  domains?: StoreDomainDto[];
}

export function ConfiguringDomainAlert({
  domains,
}: Readonly<ConfiguringDomainAlertProps>) {
  const t = useTranslationConfigurations('domains.configuringDomainAlert');

  const configuringDomain = useMemo(() => {
    if (!domains) return null;

    return domains.find(
      (domain) => domain.isOurDomain && domain.status.domain === 'needs_dns',
    );
  }, [domains]);

  if (!configuringDomain) return null;

  return (
    <Alert appearance="warning" title="">
      <Box display="flex" flexDirection="column" gap="1">
        <Box fontWeight="medium">
          {t('title', { domainName: configuringDomain.name })}
        </Box>
        <Box>{t('subtitle')}</Box>
      </Box>
    </Alert>
  );
}
